import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IIntegration } from '../interface/core/IIntegration';

enum IntegrationServiceEnum {
  getByOfficerId = "/get-by-officer-id",
  createOfficerIntegration = "/create-officer-integration"
}

export default class IntegrationService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/partner");
  }

  public getByOfficerId = async (id: number): Promise<IIntegration[]> => await this.GET(`${IntegrationServiceEnum.getByOfficerId}/${id}`);
  public createOfficerIntegration = async (id: number, request: IIntegration): Promise<any> => await this.POST(`${IntegrationServiceEnum.createOfficerIntegration}/${id}`, request);
}
